module.exports = __webpack_public_path__ + "media/images/icons/modal-close-f1a846c2741e1786208fbce3491de94b.svg";